import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PmcCaseNumLookupComponent } from './pmc-case-num-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [PmcCaseNumLookupComponent],
  exports: [PmcCaseNumLookupComponent]
})
export class PmcCaseNumLookupModule { }
